var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResumEicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d3354f;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.66,9.63a.25.25,0,0,1,0-.07,4.28,4.28,0,0,0-.79-1.15L20.59,3.17A4,4,0,0,0,17.76,2H8A3,3,0,0,0,5,5V27a3,3,0,0,0,3,3H24a3,3,0,0,0,3-3V11.24A4,4,0,0,0,26.66,9.63ZM20,5.41,23.59,9H21a1,1,0,0,1-1-1ZM25,27a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V5A1,1,0,0,1,8,4h9.76L18,4V8a3,3,0,0,0,3,3h4a1.94,1.94,0,0,1,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.29,19.29,11,20.59l-.29-.3a1,1,0,0,0-1.42,1.42l1,1a1,1,0,0,0,1.42,0l2-2a1,1,0,0,0-1.42-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.29,13.29,11,14.59l-.29-.3a1,1,0,0,0-1.42,1.42l1,1a1,1,0,0,0,1.42,0l2-2a1,1,0,0,0-1.42-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,14H17a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,20H17a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumEicon);
export default __webpack_public_path__ + "static/media/RESUMEicon.d194116f4c655dd59db79881202d86f8.svg";
export { ForwardRef as ReactComponent };